import { render, staticRenderFns } from "./field-setup.vue?vue&type=template&id=5eefc0dd&scoped=true&"
import script from "./field-setup.vue?vue&type=script&lang=js&"
export * from "./field-setup.vue?vue&type=script&lang=js&"
import style0 from "./field-setup.vue?vue&type=style&index=0&id=5eefc0dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eefc0dd",
  null
  
)

export default component.exports